import React, { useEffect, useState } from "react";
import Header from "../../components/header/header";
import ContactUs from "../../components/ContactUs/ContactUs";
import { CONTACT_US_TRIGER, GOLD_QUANTITY_LIST, SUBSCRIPTION_MODULE_TYPE } from "../../constants";
import Currency from "../../components/currency/currency";
import CurrencyFormat from "../../components/currencyFormat/currencyFormat";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import {
  getStripeCards,
  manualPaymentAction,
  setPaymentMethodSelection,
  setPaymentSteps,
  setQuantity,
  setTripleaUrl,
} from "../../actions/stripe";
import ContentLoader from "react-content-loader";
import { getCapitalList, getPaidUpById } from "../../actions/capital";
import { PRODUCT_PLAN_LOADER } from "../../actions/types";

export default function PaidUpDetalPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pathnames = location?.pathname?.split("/").filter((x) => x);
  const { paidUpAmountPaid } = useSelector((state) => state.capital);

  const planId = location?.pathname?.split("/").pop();
  const [activeSegment, setActiveSegment] = useState(1)
  const { selectedCompany } = useSelector((state) => state.company);

  const { stripePlans, paymentMethodSelection, stripeType } = useSelector((state) => state.stripe);
  const { selectedPlanProduct, planLoader, selectedPlanProductCurrentPage } = useSelector((state) => state.subscriptionPlanProducts);

  useEffect(() => {
    dispatch(getStripeCards());
  }, [dispatch, selectedCompany])


  useEffect(() => {
    getPaidupDetail()
  }, [dispatch, selectedCompany])



  const getPaidupDetail = async () => {
    dispatch({ type: PRODUCT_PLAN_LOADER, payload: true });

    const { id } = selectedCompany;
    if (id) {
      var response = await dispatch(getCapitalList(id))
      if (planId) {
        var resp = await dispatch(getPaidUpById(planId, selectedPlanProductCurrentPage, true, response?.paidUpAmountPaid));
      } else {
        navigate(RoutesPaths.PAYMENT);
      }
    }

  };


  useEffect(() => {
    if (stripePlans && stripePlans?.supportedPaymentMethod?.length > 0) {
      dispatch(setPaymentMethodSelection(paymentMethodSelection ? paymentMethodSelection : stripePlans?.supportedPaymentMethod[0]?.value));
    }
  }, [stripePlans, selectedPlanProduct]);

  const forwardPaymentPage = async () => {
    if (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL || parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS) {
      dispatch(manualPaymentAction(stripePlans?.price))
    } else {
      dispatch(manualPaymentAction(0))
    }
    dispatch(setQuantity(GOLD_QUANTITY_LIST[0]))
    dispatch(setPaymentSteps(1));
    dispatch(setTripleaUrl(null, false))
    if (pathnames[0] === 'payment') {
      navigate(RoutesPaths.PAYMENT_BANK_TRANSFER.replace(":slug", planId));
    } else {
      navigate(RoutesPaths.PAY_PAIDUP_BANKTRANSFER.replace(":slug", planId));
    }
  };

  const segmentArray = [
    { label: "Key features", value: 1 },
    { label: "Highlights", value: 2 }
  ]

  const handleSegment = (value) => {
    setActiveSegment(value)
  }
  return (
    <>
      <Header title="Product" subtitle="Product" />

      <div className="container-fluid minHeightVH py-4 paymentPage paddingBottomMD">
        {planLoader ? (
          <div className="row">
            <div className="col-12 col-md-4">
              <ContentLoader width={"100%"} height={164}>
                <rect rx="5" ry="5" width={"100%"} height="164" />
              </ContentLoader>
              <div className="row mt-2">
                <div className="col-md-4">
                  <ContentLoader width={"100%"} height={30}>
                    <rect rx="5" ry="5" width={"100%"} height={50} />
                  </ContentLoader>
                </div>
              </div>
              <div className="row mt-2">
                {[1, 2, 3].map((item, index) => (
                  <div key={index} className="col-md-4">
                    <ContentLoader width={"100%"} height={50}>
                      <rect rx="5" ry="5" width={"100%"} height={50} />
                    </ContentLoader>
                  </div>
                ))}
              </div>
              <div className="row mt-4">
                {[1, 2].map((item, index) => (
                  <div key={index} className="col-md-6">
                    <ContentLoader width={"100%"} height={50}>
                      <rect rx="5" ry="5" width={"100%"} height={50} />
                    </ContentLoader>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-12 col-md-8">
              {[
                100, 90, 80, 70, 80, 75, 65, 60, 50, 55, 60, 90, 65, 70, 80,
              ].map((item, index) => (
                <ContentLoader key={index} width={item + "%"} height={15}>
                  <rect rx="5" ry="5" width={item + "%"} height="15" />
                </ContentLoader>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="productPlanCta">
                  <div className="productImageHolder">
                    <div
                      className="productImage"
                      style={{
                        backgroundImage: `url(${stripePlans?.image})`,
                      }}></div>
                  </div>
                  <div className="choosePaymentMethod">
                    <div className="row">
                      <div className="col-6">
                        <div
                          onClick={forwardPaymentPage}
                          className="productUpgradePlanBtn">
                          Deposit capital
                        </div>
                      </div>
                      <div className="col-6">
                        <ContactUs
                          theme="planContactUS"
                          subscriptionPlanName={stripePlans?.name}
                          type={
                            stripePlans?.planType?.value ===
                              SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL
                              ? CONTACT_US_TRIGER.PAID_UP_CAPITAL_PAYMENT
                              : CONTACT_US_TRIGER.PAYMENT
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-8">
                <div className="productPlanHolder">
                  <div className="productPlanPriceHolder">
                    <h4 className="productplanTitle">
                      {stripePlans?.name || "-"}
                    </h4>
                    <p className="recumentPrice">
                      <Currency currency={stripePlans?.currency?.value} />{" "}
                      <CurrencyFormat
                        currency={stripePlans?.currency?.value}
                        value={parseFloat(stripePlans?.price)}
                        decimal={2}
                      />
                    </p>
                    {stripePlans?.smallDescription && (
                      <p className="productSlug">
                        {stripePlans?.smallDescription}
                      </p>
                    )}
                  </div>
                  <div className="planTabsHolder">
                    {segmentArray?.map((item, index) => (
                      <div onClick={() => handleSegment(item?.value)} key={index} className={`planTabs ${item?.value === activeSegment ? 'active' : ""}`}>
                        <p>{item.label}</p>
                      </div>
                    ))}
                  </div>
                  {activeSegment === 2 &&
                    <div
                      className="planDescription"
                      dangerouslySetInnerHTML={{
                        __html: stripePlans?.targetAudience || "-",
                      }}></div>
                  }
                  {activeSegment === 1 &&
                    <div className="row top-section">
                      {stripePlans?.assuredFeature &&
                        stripePlans?.assuredFeature?.length > 0 && (
                          <div className="col-md-6">
                            <h6 className="BottomBankPlantitle">
                              You are assured of:
                            </h6>
                            {stripePlans?.assuredFeature?.map((item, index) => (
                              <div key={index} className="youAreAssignReceive">
                                <img src="assets/img/assuerdIcon.svg" alt="" />
                                <p>{item}</p>
                              </div>
                            ))}
                          </div>
                        )}

                      {stripePlans?.guarentedFeature &&
                        stripePlans?.guarentedFeature?.length > 0 && (
                          <div className="col-md-6">
                            <h6 className="BottomBankPlantitle">
                              You are guaranteed to receive:
                            </h6>
                            {stripePlans?.guarentedFeature?.map((item, index) => (
                              <div key={index} className="youAreAssignReceive">
                                <img src="assets/img/assuerdIcon.svg" alt="" />
                                <p>{item}</p>
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                  }
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
